export enum PageModesEnum {
  DEFAULT,
  PROFILE,
}
